import i18n from '@/lang/i18n'

export default [{
  path: '/admin/apply/distribution/distributor/list',
  name: 'distributionDistributorList',
  component: () => import('@/views/apply/distribution/distributor/index'),
  meta: {
    title: i18n.t('router.distribution.distributor_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/distributor/detail',
  name: 'distributionDistributorDetail',
  component: () => import('@/views/apply/distribution/distributor/detail'),
  meta: {
    title: i18n.t('router.distribution.distributor_detail'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/application/list',
  name: 'distributionApplicationList',
  component: () => import('@/views/apply/distribution/application/index'),
  meta: {
    title: i18n.t('router.distribution.distribution_audit'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/level/list',
  name: 'distributionLevelList',
  component: () => import('@/views/apply/distribution/level/index'),
  meta: {
    title: i18n.t('router.distribution.distribution_level'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/config/index',
  name: 'distributionConfig',
  component: () => import('@/views/apply/distribution/config/index.vue'),
  meta: {
    title: i18n.t('router.distribution.distribution_config'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/upgrade_log/list',
  name: 'distributionUpgradeLog',
  component: () => import('@/views/apply/distribution/upgrade_log/index.vue'),
  meta: {
    title: i18n.t('router.distribution.upgrade_logs'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/commission/list',
  name: 'distributionCommissionList',
  component: () => import('@/views/apply/distribution/commission/index.vue'),
  meta: {
    title: i18n.t('router.distribution.distribution_orders'),
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/distribution.js